<section class="agreement-expired-section">
    <div class="agreement-expired-wrapper">
        <div class="agreement-expired-custom-icon-wrapper">
            <i class="icon icon-edponline-Bra-107 agreement-expired-custom-icon"></i>
        </div>
        <div class="agreement-expired-helper-wrapper">
            <p class="agreement-expired-helper-title">{{ "pt.edp.edponline.agreement.expired.title.label" | translate }}</p>
            <p class="agreement-expired-helper-description">
                {{ "pt.edp.edponline.agreement.expired.description.label" | translate }}
            </p>
        </div>
        <div class="agreement-expired-custom-button-wrapper">
            <button (click)="user ? close() : onAgreementGenerate(captchaRef)" class="agreement-expired-custom-button standard">
                {{ "pt.edp.edponline.agreement.expired.button.new.request.label" | translate }}
            </button>
            <button (click)="close()" class="agreement-expired-custom-button outline">
                {{ "pt.edp.edponline.agreement.expired.button.close.label" | translate }}
            </button>
        </div>
    </div>
</section>
<div class="recaptcha-wrapper">
    <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" size="invisible"></re-captcha>
</div>
